import { render, staticRenderFns } from "./DdlStateComponent.vue?vue&type=template&id=27196464"
import script from "./DdlStateComponent.vue?vue&type=script&lang=js"
export * from "./DdlStateComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports